// default-translations.ts
var filterTranslations = {
  units: {
    years: ["Jahre", "Years"],
    months: ["Monate", "Months"],
    weeks: ["Wochen", "Weeks"],
    days: ["Tage", "Days"],
    hours: ["Stunden", "Hours"],
    minutes: ["Minuten", "Minutes"],
    seconds: ["Sekunden", "Seconds"]
  },
  filter: {
    showFilter: ["Filter", "Show Filter"],
    hideFilter: ["einklappen", "hide"],
    addFilter: ["Filter-Feld hinzuf\xFCgen", "Add Filter Field"],
    resetFilter: ["zur\xFCcksetzen", "Reset"],
    applyFilter: ["anwenden", "Apply"],
    incomplete: ["unvollst\xE4ndig", "Incomplete"],
    invalidAspect: ["Ung\xFCltiger Filter", "Invalid Aspect"],
    addFields: ["Felder hinzuf\xFCgen", "Add Fields"],
    search: ["Suchen...", "Search..."],
    delete: ["L\xF6schen", "Delete"],
    noEditor: ["Kein Editor Implementiert", "No Editor Implemented"],
    true: ["ja", "yes"],
    false: ["nein", "no"],
    empty: ["leer", "empty"]
  },
  field: {},
  class: {
    ExistsAspect: ["existiert", "exists"],
    DoesNotExistAspect: ["existiert nicht", "does not exist"],
    BooleanAspect: ["ist", "is"],
    DateTimeAspect: ["Datum", "Date"],
    DateTimeRANGEAspect: ["ist inklusiv zwischen", "is inclusive between"],
    DateTimeISAspect: ["ist", "is"],
    DateTimeBEFOREAspect: ["ist vor", "is before"],
    DateTimeAFTERAspect: ["ist nach", "is after"],
    DateTimeBEFORETODAYAspect: ["ist X vor heute", "is X before today"],
    DateTimeAFTERTODAYAspect: ["ist X nach heute", "is X after today"],
    EnumAspect: ["ist", "is"],
    StringAspect: ["Text", "Text"],
    StringEQUALSAspect: ["ist gleich", "is equal to"],
    StringSTARTSAspect: ["startet mit", "starts with"],
    StringENDSAspect: ["endet mit", "ends with"],
    StringCONTAINSAspect: ["beinhaltet", "contains"],
    StringREGEXAspect: ["erf\xFCllt Regex", "matches regex"],
    StringEMPTYAspect: ["ist leer", "is empty"],
    StringCONTAINSORAspect: ["beinhaltet eins von", "contains one of"],
    StringCONTAINSANDAspect: ["beinhaltet alle von", "contains all of"],
    StringCONTAINSNONEAspect: ["beinhaltet keines von", "contains none of"],
    IntAspect: ["Zahl", "Integer number"],
    IntRANGEAspect: ["ist zwischen", "is between"],
    IntEQUALSAspect: ["ist gleich", "equals"],
    IntISLOWERAspect: ["ist kleiner-gleich", "is less than or equal to"],
    IntISHIGHERAspect: ["ist gr\xF6\xDFer-gleich", "is greater than or equal to"],
    FloatAspect: ["Gleitkommazahl", "Float number"],
    ListAspect: ["ist", "is"],
    ListAspectCONTAINSORAspect: ["oder", "or"],
    ListAspectCONTAINSANDAspect: ["und", "and"],
    ListAspectCONTAINSNONEAspect: ["keines", "none"],
    ListAspectEMPTYAspect: ["leer", "empty"]
  }
};
export {
  filterTranslations
};
